import React from 'react';
import { Typography } from '@mui/material';

import { BadgeWrapper } from '../styled';
import { BadgeProps } from '../types';

export const Badge = ({ badgeContent, ...boxProps }: BadgeProps) => {
  if (badgeContent) {
    return (
      <BadgeWrapper
        padding={badgeContent > 100 ? '0 3px' : undefined}
        {...boxProps}
      >
        <Typography fontSize="14px" lineHeight="18px" fontWeight={600}>
          {badgeContent}
        </Typography>
      </BadgeWrapper>
    );
  }

  return null;
};
